import { useEffect, useMemo } from "react";
import {
  List,
  TextField,
  DatagridConfigurable,
  useTheme,
} from "react-admin";
import DownloadAction from "../../components/tableListActions/DownloadAction";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import transactionHistoryFilterList from "../../components/transactionHistories/filter/transactionHistoryFilterList";
import TransactionHistoryExpandList from "../../components/transactionHistories/expand/TransactionHistoryExpandList";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";

// const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();

const ExpandAll = () => {
  useEffect(() => {
    const expandAllBtn = document.querySelector(
      "table.RaDatagrid-table .RaDatagrid-thead .RaDatagrid-headerRow .RaDatagrid-expandHeader .RaDatagrid-expandIcon:not(.RaDatagrid-expanded)"
    );
    if (expandAllBtn) {
      var clickEvent = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false,
      });
      expandAllBtn.dispatchEvent(clickEvent);
    }
  }, []);
  return null;
};

const TransactionHistoryList = () => {
  const { permissions, canSeeCompanyColumn, filterDefaultValues } =
    useCompanyScopedListFilters();
  const [theme] = useTheme("light");

  const list = useMemo(
    () => (
      <List
        title="mine.label.transaction_history"
        empty={false}
        actions={<DownloadAction />}
        filters={transactionHistoryFilterList(permissions)}
        filterDefaultValues={filterDefaultValues}
        queryOptions={{ meta: { sort: ["created_at DESC"] } }} // overide default sort
        // filterDefaultValues={{
        //   start_date: firstDate,
        //   end_date: lastDate,
        // }}
      >
        <DatagridConfigurable
          bulkActionButtons={false}
          expand={<TransactionHistoryExpandList />}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          {canSeeCompanyColumn ? (
            <TextField label="Company" source="company.alias" />
          ) : null}
          <TextField source="code" label="mine.label.receipt_no" />
          <ExpandAll />
        </DatagridConfigurable>
      </List>
    ),
    [theme, permissions, canSeeCompanyColumn, filterDefaultValues]
  );
  return list;
};

export default TransactionHistoryList;
